<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-01 08:39:06
    Description : 作品 的卡片
  -->
  <div class="gaia-card">
    <img class="cover" :src="getCover()" @click="$emit('click')" />
    <div class="time">{{ getVideoDuration() }}</div>
    <div class="info" @click="$emit('click')">
      <div class="title">{{ data.title }}</div>
      <div class="keywords">
        {{ data.keyword ? unescape(data.keyword) : "" }}
      </div>
      <div style="height: 10px; border-bottom: solid 1px #f2f2f2"></div>
      <div class="count" v-if="data.statistics">
        <play-one
          theme="filled"
          size="16"
          fill="#c7c7c7"
          style="margin-left: -3px"
        />
        <span class="playCount">{{ data.statistics.playCount }}</span>
      </div>
    </div>
    <div v-if="showUser" class="user">
      <div class="cover">
        <el-avatar :size="24" :src="baseUrl + data.user.avatar">
          <img :src="VUE_APP_DEFAULTAVATAR" />
        </el-avatar>
      </div>
      <div
        class="nickname"
        @click="open(`/desktop/center/${data.user.account.id}`)"
      >
        {{ data.user.nickname }}
      </div>
    </div>
  </div>
</template>

<script>
import { PlayOne } from "@icon-park/vue";
import { timeConversion } from "@/utils/utils";
export default {
  components: {
    PlayOne,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      VUE_APP_DEFAULTAVATAR: process.env.VUE_APP_DEFAULTAVATAR,
    };
  },
  created() {},
  methods: {
    open(url) {
      open(url);
    },
    unescape(val) {
      return unescape(val);
    },
    getVideoDuration() {
      const data = this.data;
      if (data && data.video && data.video.videoInfo) {
        return timeConversion(data.video.videoInfo.duration);
      } else {
        return "-- : --";
      }
    },
    getCover() {
      const data = this.data;
      if (data.cover && !data.cover.includes("screenshot")) {
        return this.baseUrl + data.cover;
      }
      let cover = "";
      data.video.resources.map((el) => {
        if (el.resourceName === "180") {
          cover = this.baseUrl + el.resourceKey;
        }
      });
      return cover;
    },
  },
};
</script>

<style lang="less" scoped>
.gaia-card {
  display: inline-block;
  width: 275px;
  height: 264px;
  background: #ffffff;
  cursor: pointer;
  .cover {
    display: block;
    width: 100%;
    height: 154px;
    overflow: hidden;
  }
  .time {
    display: inline-block;
    position: relative;
    top: -40px;
    left: 210px;
    width: auto;
    max-width: 70px;
    height: 22px;
    line-height: 22px;
    padding: 0 7px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
  }
  .info {
    margin-top: -22px;
    padding: 14px 10px;
    .title {
      font-size: 14px;
      height: 38px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 2; //显示的行
    }
    .keywords {
      font-size: 12px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 1; //显示的行
    }
    .count {
      height: 40px;
      padding-top: 4px;
      font-size: 12px;
      font-weight: bold;
      color: #a7a7a7;
      .playCount {
        vertical-align: top;
        color: #666;
      }
    }
  }
}
.user {
  display: flex;
  align-items: center;
  cursor: pointer;
  .cover {
    width: 34px;
    height: 26px;
  }
  .nickname {
    flex: 1;
    font-size: 12px;
    color: #999;
    cursor: pointer;
  }
  .nickname:hover {
    color: #ff5b67;
  }
}
</style>